import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import EditableInput from '../../components/EditableInput';
import UneditableInput from '../../components/UneditableInput';

import { updateSSl, getSSLsBySearch } from '../../services/ssl';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress, Button } from '@material-ui/core';
import { Save } from '@material-ui/icons';

const SSLInformation = props => {
  const dispatch = useDispatch();
  const [ssl, setSSL] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displaySSL();
  }, []);

  const displaySSL = async () => {
    const sslId = props.match.params.id;

    try {
      setIsLoading(true);
      const { data } = await getSSLsBySearch('id', sslId);

      setSSL(data.rows[0]);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load this SSL. 😔'));
      console.log(error);
    }
  };

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updateSSl(ssl.id, ssl);

      dispatch(showAlert('success', 'SSl has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the SSl. 😔'));
      console.log(error);
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>SSL: {ssl?.arn}</h1>
      </div>

      <section className="update-section">
        <form onSubmit={handleUpdate} className="update-form">
          <div className="form-fields">
            <EditableInput data={ssl} setData={setSSL} labels={['customDomainId', 'status']} />
            <UneditableInput data={ssl} labels={Object.keys(ssl)} />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update SSL
          </Button>
        </form>
      </section>
    </>
  );
};

export default SSLInformation;
